import React, { useEffect, useState } from "react";
import { getCouriers } from "../api/adsApi";
import CompanyCard from "../components/CompanyCard";

const CourierList = () => {

  const [couriers, setCouriers] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);

  const itemsPerPage = 29;

  useEffect(() => {
    getCouriers().then((res) => {
      setCouriers(res.data);
    });
  }, []);

  // Pagination Logic
  const lastItemIndex = currentPage * itemsPerPage;
  const firstItemIndex = lastItemIndex - itemsPerPage;
  const currentCouriers = couriers.slice(firstItemIndex, lastItemIndex);

  const totalPages = Math.ceil(couriers.length / itemsPerPage);

  return (
    <div className="container mt-5">
      <br /><br />
      <h3 className="text-center mb-5 section-title">Courier Companies</h3>

      <div className="row">
        {currentCouriers.map((company) => (
          <CompanyCard url="courier" key={company.id} company={company} />
        ))}
      </div>

      {/* Pagination */}
      <nav>
        <ul className="pagination justify-content-center mt-4">

          {[...Array(totalPages)].map((_, index) => (
            <li
              key={index}
              className={`page-item ${currentPage === index + 1 ? "active" : ""}`}
            >
              <button
                className="page-link"
                onClick={() => setCurrentPage(index + 1)}
              >
                {index + 1}
              </button>
            </li>
          ))}

        </ul>
      </nav>

    </div>
  );
};

export default CourierList;